import React from "react";
import { SelectTab } from "./style";
import SideNavItem from "./Items";

export default function UserSelectTab({ userList, onSelect }) {
  return (
    <div>
      {userList.map((user, index) => {
        return (
          <SelectTab key={index}>
            <SideNavItem
              icon={user.profileImage}
              name={user.fullName}
              message={user.matricNumber}
              onClick={() => onSelect(user.id)}
            />
          </SelectTab>
        );
      })}
    </div>
  );
}
